export { default } from './ProtectedByPermissions';
